import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/icons/webp/person-wrench.webp")